import Footer from 'components/Footer'
import Header from 'pages/Home1/Header'
import React, { useEffect, useState } from 'react'
import ImgSingin from '../../assets/images/singup.png'
import Overly from '../../assets/images/overly.png'
import InputFeild from 'components/Input/Input'
import { Button } from 'components'
import { NavLink, useNavigate } from 'react-router-dom'
import './Login.css'
import axios from 'axios'
import { ToastContainer, toast } from 'react-toastify'
import { Spinner } from 'react-bootstrap'
const Login = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    identifier: '',
    password: '',
    role: 'seller',
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (field, value) => {
    setFormData({
      ...formData,
      [field]: value
    });
  };


  const handleSignin = async (e) => {
   if (e) e.preventDefault();
  if (!formData.identifier || !formData.password) {
    toast.error('Please enter both email and password.');
    return;
  }

  setLoading(true);
    try {
      const response = await axios.post(
        'https://production.washta.com/api/auth/login',
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );
  
      const { status, code, message, data } = response.data;
      
      if (status === true && code === 200) {
        toast.success('Sign in successful!');
        console.log('Response Data:', data); 
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.setItem('accessToken', data.accessToken);
        setTimeout(() => {
          navigate('/become-a-seller/dashboard');
        }, 2000); 
      } else if (status === false && code === 200) {
        toast.warning(message);
        navigate('/not-verified'); // Navigate to not-verified page
      } else {
        toast.error('Sign in failed. Please try again.');
      }
       
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Sign in failed. Please try again.';
            if (error.response?.data?.error && error.response.data.error.includes("couldn't find user")) {
        toast.error("Email does not exist, please try again or singup");
      } else {
        toast.error(errorMessage);
      }
  
      console.error('Error:', error.response);
    } finally {
      setLoading(false);
    }
  };
  
  
  
  return (
    <>
      <Header  btnText="Become a Partner" btnLink={()=>navigate("/become-a-partner")} />
      <div style={{ position: 'relative' }}>
        <div className='row md:h-auto'>
          <img src={Overly} className='overlyClassName' alt="Logo" />
          <div className='colm-first md:w-[47%] block md:contents !important w-[47%] !important p-[2%]'> <img className='md:mt-[23%]' src={ImgSingin} alt="Logo"  /> </div>
          <div className='colm-first add  md:w-[100%] !important w-[47%] !important md:mb-[40px]'>
              <div className='innerDiv-form md:w-auto'>
                <h1 className='h1-heaing'>Welcome back! </h1>
                <p className='paragraph-otp'> Boost your business by providing your services to customers. </p>
                <form onSubmit={handleSignin}>
    <div className='gapmargin'>
      <InputFeild
        paddingBottom='4px'
        type='email'
        label="Email *"
        placeholder="Enter your Email"
        onChange={(value) => handleChange('identifier', value)}
      />
    </div>

    <div className='gapmargin'>
      <InputFeild
        paddingBottom='4px'
        type='password'
        label="Password *"
        placeholder="Enter your Password"
        onChange={(value) => handleChange('password', value)}
      />
    </div>

    <p
      className='paragraph-otp'
      style={{ marginTop: '2em', cursor: 'pointer' }}
      onClick={() =>
        navigate('/forgot-password', { state: { item: 'seller' } })
      }
    >
      Forgot Password?
    </p>

    <Button
      type="submit"
      shape="round"
      className="min-w-[100%] sm:px-1"
      style={{
        fontSize: '16px',
        background: 'white',
        color: 'black',
        marginTop: '20px',
        fontFamily: "'General Sans', sans-serif",
      }}
    >
      {loading ? (
        <Spinner
          animation="border"
          style={{
            color: '#6b5fe4',
            width: '1.5em',
            height: '1.5em',
          }}
          size="sm"
        />
      ) : (
        'Sign in'
      )}
    </Button>
  </form>
                <div className='div-singup-btn-login'>
                <p className='paragraph-otp' > Don’t have an account? </p>
                <NavLink style={{color:'white'}} to="/for-providers#apply"> Sign Up Now! </NavLink> 
                </div>
               
              </div>
            {/* )} */}
          </div>
        </div>
      </div>
      <ToastContainer/>
      <Footer />
    </>
  )
}

export default Login;